import { createReducer, createAction, PayloadAction } from "@reduxjs/toolkit";

export interface Request {
  method: "GET" | "POST";
  url: string;
}

const INITIAL_STATE: Request[] = [];

export const add = createAction<Request>("addLoading");
export const remove = createAction<Request>("removeLoading");

export default createReducer(INITIAL_STATE, {
  [add.type]: (state, action: PayloadAction<Request>) => {
    state.push(action.payload);
  },
  [remove.type]: (state, action: PayloadAction<Request>) => {
    state.splice(
      state.findIndex(
        s => s.method === action.payload.method && s.url === action.payload.url
      ),
      1
    );
  }
});
